/* eslint-disable import/prefer-default-export */

/**
 * introspects a post bundle and returns stats about its content.
 *
 * collected stats:
 *
 * - bundleItemTypes: object whose keys are bundle item types, and whose values
 *     are the occurrence count. NOTE: only includes encountered bundle item
 *     types.
 *
 * @param {Object} postBundle a bundle with layout = post
 * @param {Object[]} postBundle.items[]
 * @param {String} postBundle.items[].type bundle item type
 * @returns {Object}
 */
function getPostStats(postBundle) {
  const bundleItemTypes = (postBundle.items || []).reduce(
    (acc, curr) => ({
      ...acc,
      [curr.type]: acc[curr.type] === undefined ? 1 : acc[curr.type] + 1
    }),
    {}
  );

  return { bundleItemTypes };
}

/**
 * introspects the provided content bundles (and their items) and returns
 * an aggregate stats object, with the bundle type as the top-level key.
 *
 * handled bundle types: post
 *
 * @export
 * @param {Object[]} [contentBundles=[]]
 * @param {String} [contentBundles[].layout] bundle layout (post, etc.)
 * @returns {Object} aggregate stats about the content bundles
 */
export function deriveContentStats(contentBundles = []) {
  // NOTE: we're assuming one post per page for now
  const postBundle = contentBundles.find(b => b.layout === 'post');
  const postStats = postBundle ? getPostStats(postBundle) : null;

  return {
    post: postStats
  };
}
